import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { DataService } from '../data.service';
import { StudyReportSearchItem } from '../../model/study-report-search-item';
import { StudyReportLogisticsComment } from '../../model/study-report/study-report-logistics-comment';

@Injectable({
  providedIn: 'root'
})
export class StudyReportLogisticsCommentService { 
 
  constructor(private dataService: DataService) { } 
  private readonly base: string = '/studyReportLogisticsComment';
  
  async GetByStudyReportId(studyReportId: number): Promise<StudyReportLogisticsComment[]> { 
    const params = { studyReportId: studyReportId };
    return await this.dataService
      .get<StudyReportLogisticsComment[]>(`${this.base}/getByStudyReportId`, params).toPromise();
  }
 
  async create(comment:string, studyReportId: number): Promise<boolean> {
    console.log(comment);
    const params = { Comment: comment, StudyReportId: studyReportId };
    return await this.dataService.post<boolean>(`${this.base}`, params).toPromise();
  }
}
